import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
const GoalValue = ({
  value
}) => {
  if (value === null || value === undefined) {
    return '-';
  } else {
    const splitValue = value.toFixed(1).toString().split('.');
    return /*#__PURE__*/React.createElement(React.Fragment, null, splitValue[0], ".", /*#__PURE__*/React.createElement("span", null, splitValue[1], "%"));
  }
};
export default function Goal({
  value,
  name,
  accent_color,
  width,
  fontStyles
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "goal",
    style: {
      width
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "goal-percentage"
  }, /*#__PURE__*/React.createElement("p", {
    className: "goal-value",
    style: {
      color: fontStyles.color
    }
  }, /*#__PURE__*/React.createElement(GoalValue, {
    value: value
  })), /*#__PURE__*/React.createElement(CircularProgressbar, {
    strokeWidth: 10,
    value: value === null ? 0 : value,
    styles: {
      // Customize the root svg element
      root: {
        maxHeight: 300
      },
      // Customize the path, i.e. the "completed progress"
      path: {
        // Path color
        stroke: accent_color,
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'butt',
        // Customize transition animation
        transition: 'stroke-dashoffset 0.5s ease 0s',
        // Rotate the path
        transformOrigin: 'center center'
      },
      // Customize the circle behind the path, i.e. the "total progress"
      trail: {
        // Trail color
        stroke: '#D8D8D8',
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'butt',
        // Rotate the trail
        transform: 'rotate(0.25turn)',
        transformOrigin: 'center center'
      },
      // Customize the text
      text: {
        // Text color
        fill: '#393938',
        // Text size
        fontSize: '21px',
        fontWeight: 'bold'
      },
      // Customize background - only used when the `background` prop is true
      background: {
        fill: accent_color
      }
    }
  })), /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: fontStyles
  }, name));
}